module.exports = __webpack_public_path__ + "images/for_company_page/point2-2_ff0fd612db784748000cdf9964db5b1f.jpg";